import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import swal from "sweetalert";
import { getToken } from "../utils/auth";
import "./StudyMaterialList.css";

const API_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:3001";

const StudyMaterialList = () => {
  const [materials, setMaterials] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchMaterials = async () => {
  try {
    const response = await fetch(`${API_URL}/api/study-material/getAll`, {
      headers: { Authorization: `Bearer ${getToken()}` }
    });
    
    if (!response.ok) {
      throw new Error("Failed to fetch materials");
    }
    
    const result = await response.json();

    // 1. If your backend returns { data: [...] }
    if (result && Array.isArray(result.data)) {
      setMaterials(result.data);
    } 
    // 2. If your backend returns the array directly [...]
    else if (Array.isArray(result)) {
      setMaterials(result);
    } 
    else {
      // If it's something else, we set it to an empty array to prevent the crash
      console.error("API did not return an array:", result);
      setMaterials([]);
    }

  } catch (err) {
    console.error(err);
    swal("Error", "Could not load study materials", "error");
    setMaterials([]); // Fallback to empty array on error
  } finally {
    setLoading(false);
  }
};

    fetchMaterials();
  }, []);

  if (loading) return <div className="loader">Loading courses...</div>;

  return (
    <div className="list-container">
      <h2>Available Courses</h2>
      {materials.length === 0 ? (
        <p>No study materials found.</p>
      ) : (
        <ul className="course-list">
          {materials.map((item) => (
            <li key={item._id} className="course-item">
              {/* Navigate to the detail page using the ID */}
              <Link to={`/material/${item._id}`} className="course-link">
                {item.course}
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default StudyMaterialList;